const bankList = [
  "Commercial Bank of Ethiopia",
  "telebirr",
  "Cash",
  "Awash International Bank",
  "Dashen Bank",
  "Bank of Abyssinia",
  "Cooperative Bank of Oromia",
  "Enat Bank",
  "Zemen Bank",
  "Bunna International Bank",
  "Wegagen Bank",
  "Berhan International Bank",
  "Lion International Bank",
  "Nib International Bank",
  "Amhara Bank",
  "Global Bank Ethiopia",
  "Oromia International Bank",
  "Hibret Bank",
  "Abay Bank",
  "Ahadu Bank",
  "Gadaa Bank",
  "Tsedey Bank",
  "Hijra Bank",
  "Siinqee Bank",
  "Shabelle Bank",
  "Rammis Bank",
  "Tsehay Bank",
  "Goh Betoch Bank",
  "Sidama Bank",
  "Omo Bank",
  "ZamZam Bank",
];

export default bankList;